import { Info } from '@magnetic/icons';
import { Tooltip } from '@magnetic/tooltip';
import React, { cloneElement } from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const InputTooltip = /* @__PURE__ */ __name(({ tooltip }) => {
  const isString = typeof tooltip === "string";
  return /* @__PURE__ */ React.createElement(Tooltip, {
    className: "mds-rebuild-input-tooltip",
    title: isString ? tooltip : tooltip.content
  }, isString ? /* @__PURE__ */ React.createElement(Info, {
    "aria-label": tooltip,
    color: "var(--interact-icon-weak)",
    height: 16,
    tabIndex: 0,
    width: 16
  }) : cloneElement(tooltip.icon, {
    "aria-label": tooltip.content,
    color: "var(--interact-icon-weak)",
    height: 16,
    tabIndex: 0,
    width: 16
  }));
}, "InputTooltip");
InputTooltip.displayName = "Input.Tooltip";

export { InputTooltip };
//# sourceMappingURL=input-tooltip.js.map
